import { useAuth } from "../lib/auth";
import { LogOut, User } from "lucide-react";
import { Link } from "react-router-dom";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem,
  DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger,
} from "./ui/dropdown-menu";

/**
 * Each breadcrumb item can be a plain string (non-clickable) or
 * an object {label, to} where `to` is a router path.
 */
export default function Topbar({ breadcrumbs = [] }) {
  const { user, logout } = useAuth();

  return (
    <header className="sticky top-0 z-30 bg-background/95 backdrop-blur border-b border-border">
      <div className="px-6 h-14 flex items-center justify-between">
        <nav className="text-xs text-muted-foreground flex items-center gap-2" data-testid="breadcrumb">
          {breadcrumbs.map((b, i) => {
            const item = typeof b === "string" ? { label: b } : b;
            const isLast = i === breadcrumbs.length - 1;
            const labelCls = isLast
              ? "text-foreground font-medium"
              : "hover:text-primary transition-colors";
            return (
              <span key={i} className="flex items-center gap-2">
                {i > 0 && <span className="text-slate-300">/</span>}
                {item.to && !isLast ? (
                  <Link
                    to={item.to}
                    className={labelCls}
                    data-testid={`breadcrumb-link-${i}`}
                  >
                    {item.label}
                  </Link>
                ) : (
                  <span className={labelCls}>{item.label}</span>
                )}
              </span>
            );
          })}
        </nav>
        <div className="flex items-center gap-3">
          <span className="kbd">Remi8 · POC</span>
          {user && (
            <DropdownMenu>
              <DropdownMenuTrigger asChild>
                <button data-testid="user-menu-trigger" className="flex items-center gap-2 rounded-md hover:bg-secondary/60 px-2 py-1 transition-colors">
                  <div className="size-7 rounded-full bg-primary text-white grid place-items-center text-[11px] font-bold">
                    {(user.full_name || user.email).slice(0,2).toUpperCase()}
                  </div>
                  <div className="hidden md:block text-left leading-tight">
                    <div className="text-xs font-medium">{user.full_name}</div>
                    <div className="text-[10px] text-muted-foreground">{user.role} · {user.designation}</div>
                  </div>
                </button>
              </DropdownMenuTrigger>
              <DropdownMenuContent align="end" className="w-56">
                <DropdownMenuLabel>{user.email}</DropdownMenuLabel>
                <DropdownMenuSeparator />
                <DropdownMenuItem disabled><User className="size-4 mr-2" /> Profile</DropdownMenuItem>
                <DropdownMenuItem onClick={logout} data-testid="logout-button">
                  <LogOut className="size-4 mr-2" /> Logout
                </DropdownMenuItem>
              </DropdownMenuContent>
            </DropdownMenu>
          )}
        </div>
      </div>
    </header>
  );
}
